export const CHART_COLORS = {
	offPeak: "#40cdc2",
	peak: "#ff2499",
	subscription: "#42445D",

	offPeak2024: "#EF9C88",
	peak2024: "#E76E50",
	offPeak2025: "#4EBCC3",
	peak2025: "#2A9D90",
};
